import React, { Component } from "react";
import axios from "axios";
import RichTextEditor from "react-rte";
import IdleTimer from "react-idle-timer";
import SpinnerLoad from "./SpinnerLoad";
import CryptoJS from "crypto-js";
import Header from "./Header";
import Footer from "./Footer";
import InternalServerError from "./InternalServerError";
import xss from "../../node_modules/xss";
import { withToastManager } from "react-toast-notifications";
import attackDetection from "../../node_modules/xss-attack-detection";
const xss_detect = new attackDetection.xssAttackDetection();

class CustomerPortal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: RichTextEditor.createValueFromString("", "html"),
      data: "",
      commentDetails: [],
      showTextEditor: false,
      btnActive: true,
      RTELength: 0,
      xssError: "",
      validInput: true,
    };
    this.onDownloadLink = this.onDownloadLink.bind(this);
    this.onReplyBtnClick = this.onReplyBtnClick.bind(this);
    this.onChangeActivityEditor = this.onChangeActivityEditor.bind(this);
    this.onResetState = this.onResetState.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.countDown = this.countDown.bind(this);

    // Listen to storage event
    window.addEventListener("storage", (e) => this.storageChanged(e));

    // Bind this to storageChanged()
    this.storageChanged = this.storageChanged.bind(this);
  }

  storageChanged(e) {
    if (e.key === "loggedIn") {
      if (window.localStorage.getItem("loggedIn")) {
        this.onLogout();
      }
      if (
        e.key === "refresh_token_expire" &&
        window.localStorage.getItem("refresh_token_expire") === 0
      ) {
        this.onLogout();
      }
    }
  }

  onChangeActivityEditor(value) {
    this.setState({ value });
    let str = value
      .toString("html")
      .replace(/(<([^>]+)>)/g, "")
      .replace(/&nbsp;/gi, "");
    let strLen = str.replace(/[\r\n]+/gm, "").length;
    this.setState({ RTELength: strLen });

    if (
      xss_detect.detect(str).gist === "malicious" &&
      xss_detect.detect(str).confidenceFactor > 90
    ) {
      this.setState({
        xssError: "Please enter a valid input",
        validInput: false,
      });
    } else {
      this.setState({ validInput: true, xssError: "" });
    }
  }

  handleLogout() {
    window.localStorage.setItem("loggedIn", false);
    var _this = this;
    setTimeout(() => {
      _this.onLogout();
    }, 1000);
  }

  onLogout() {
    this.props.history.push("/Logout");
  }

  componentWillMount() {
    setInterval(this.countDown, 1000);
    window.localStorage.setItem("loggedIn", true);
    this.getComments();
  }

  countDown() {
    if (window.localStorage.getItem("refresh_token_expire") > 0) {
      window.localStorage.setItem(
        "refresh_token_expire",
        window.localStorage.getItem("refresh_token_expire") - 1
      );
    } else {
      this.onLogout();
    }
  }

  async getComments() {
    var Data =
      "requestId=" + window.localStorage.getItem("requestID") + "&isExternal=Y";
    var encryptedData = CryptoJS.AES.encrypt(
      Data,
      this.props.password
    ).toString();
    var obj = {
      url:
        process.env.REACT_APP_DPR_API_URL + "/PublicComment?" + encryptedData,
      method: "GET",
    };
    try {
      const response = await axios({
        url: "/servercall/DPRAPI",
        method: "POST",
        data: obj,
      });

      let bytes = CryptoJS.AES.decrypt(response.data, this.props.password);
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.setState({ commentDetails: decryptRes });
    } catch (e) {
      console.log(e);
      this.setState({ internalServerError: true });
    }
  }

  async componentDidMount() {
    var Data =
      "search=" +
      window.localStorage.getItem("requestID") +
      "&pageNo=1&records=20";
    var encryptedData = CryptoJS.AES.encrypt(
      Data,
      this.props.password
    ).toString();

    var obj = {
      url:
        process.env.REACT_APP_DPR_API_URL +
        "/PublicSearchRequests?" +
        encryptedData,
      method: "GET",
    };

    try {
      const response = await axios({
        url: "/servercall/DPRAPI",
        method: "POST",
        data: obj,
      });
      let bytes = CryptoJS.AES.decrypt(response.data, this.props.password);
      let decryptRes = JSON.parse(
        JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      );
      this.setState({ data: decryptRes.data[0] });
    } catch (e) {
      console.log(e);
      this.setState({ internalServerError: true });
      return e;
    }
  }

  async onDownloadLink() {
    console.log('requestID ', window.localStorage.getItem("requestID"))
    var Data =
      "opType=requestInfo&requestId=" +
      window.localStorage.getItem("requestID");
    var encryptedData = CryptoJS.AES.encrypt(
      Data,
      this.props.password
    ).toString();
    var obj = {
      url:
        process.env.REACT_APP_DPR_API_URL + "/PublicGetFile?" + encryptedData,
      method: "GET",
    };
    try {
      const response = await axios({
        url: "/servercall/DPRAPI",
        method: "POST",
        data: obj,
      });
      console.log('response.data ', response.data)
      let bytes = CryptoJS.AES.decrypt(response.data, this.props.password);
      let decryptRes = JSON.parse(JSON.parse(bytes.toString(CryptoJS.enc.Utf8)));
      console.log('decryptRes ', decryptRes)
      let iterations = 128;
      let requestIds = [];
      decryptRes.forEach(requestId => {
        let bytes = CryptoJS.PBKDF2(this.props.password, this.props.salt, { keySize: 48, iterations: iterations });
        let iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
        let key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));
        var ciphertext = CryptoJS.enc.Base64.parse(requestId);
        var decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
          iv: iv
        });
        requestIds.push(decrypted.toString(CryptoJS.enc.Utf8));
      });
      const decryptedJsonArray = requestIds.map(item => JSON.parse(item));
      console.log('Decrypted requestId:', decryptedJsonArray);

      if (decryptedJsonArray.message === "Internal Server Error") {
        console.log(decryptedJsonArray);
      } else {
        if (decryptedJsonArray.includes("Data Not Found")) {
          this.props.toastManager.add("No data found!", {
            appearance: "info",
            autoDismiss: true,
          });
        } else {
          this.download("7-11PrivacyResponseData.csv", decryptedJsonArray);
        }
      }
    } catch (e) {
      console.log(e);
      this.setState({ internalServerError: true });
      return e;
    }
  }

  download(filename, json) {
    // const dictionaryKeys = Object.keys(json[0]);
    // const dictValuesAsCsv = json.map((dict) =>
    //   dictionaryKeys.map((key) => dict[key]).join(",")
    // );
    // const result = [dictionaryKeys.join(","), ...dictValuesAsCsv].join("\n");
    // var pom = document.createElement("a");
    // pom.setAttribute(
    //   "href",
    //   "data:text/csv;charset=utf-8," + encodeURIComponent(result)
    // );
    // pom.setAttribute("download", filename);
    // if (document.createEvent) {
    //   var event = document.createEvent("MouseEvents");
    //   event.initEvent("click", true, true);
    //   pom.dispatchEvent(event);
    // } else {
    //   pom.click();
    // }
    // Get all unique keys from the JSON array
    const dictionaryKeys = [...new Set(json.flatMap(Object.keys))];

    // Create CSV rows
    const dictValuesAsCsv = json.map((dict) =>
      dictionaryKeys.map((key) => dict[key] || "").join(",")
    );

    // Combine headers and rows
    const result = [dictionaryKeys.join(","), ...dictValuesAsCsv].join("\n");

    // Create a download link and trigger the download
    var pom = document.createElement("a");
    pom.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(result)
    );
    pom.setAttribute("download", filename);

    if (document.createEvent) {
      var event = document.createEvent("MouseEvents");
      event.initEvent("click", true, true);
      pom.dispatchEvent(event);
    } else {
      pom.click();
    }
  }

  onResetState() {
    this.setState({
      value: RichTextEditor.createEmptyValue(),
      showTextEditor: false,
      validInput: true,
      xssError: "",
    });
  }

  async onReplyBtnClick() {
    if (this.state.validInput) {
      this.setState(function (state) {
        return {
          showTextEditor: !state.showTextEditor,
        };
      });
      const commentVal = this.state.value.toString("html").replace(/'/g, "`");
      if (this.state.showTextEditor) {
        var body = {
          requestId: [this.state.data.request_id],
          comment: commentVal,
          commentBy: this.state.data.contact_email,
          isExternal: "Y",
          isReply: "Y",
        };
        var obj = {
          url: process.env.REACT_APP_DPR_API_URL + "/PublicPostComment",
          method: "POST",
          body: CryptoJS.AES.encrypt(
            JSON.stringify(body),
            this.props.password
          ).toString(),
        };
        try {
          const response = await axios({
            url: "/servercall/DPRAPI",
            method: "POST",
            data: obj,
          });
          let bytes = CryptoJS.AES.decrypt(response.data, this.props.password);
          let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          if (decryptRes === "REQUEST RECEIVED") {
            this.onResetState();
            this.getComments();
          }
        } catch (e) {
          console.log(e);
          this.setState({ internalServerError: true });
        }
      }
    }
  }

  onCancelBtnClick = () => {
    this.onResetState();
  };

  handleOnIdle() {
    this.props.history.push("/session-expired");
  }

  render() {
    const noBg = { background: "#fff" };
    const greyBg = { background: "#f2fbee" };
    return (
      <div className="App">
        <Header />
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          timeout={10 * 60000}
          onIdle={this.handleOnIdle}
          debounce={250}
        />
        {this.state.internalServerError ? (
          <InternalServerError />
        ) : window.localStorage.getItem("loggedIn") &&
          window.localStorage.getItem("requestID") !== null ? (
          <div className="main-content">
            <button
              type="button"
              className="position-right margin-top-1 margin-right-2"
              id="logout-button"
              onClick={this.handleLogout}
            >
              Logout
            </button>
            <div className="ccpa-wrapper clear-both">
              <div className="component-section">
                <h1>Request Details</h1>
                <div className="request-detail-panel">
                  <div className="section-col1">
                    <div className="form-element">
                      <label>Request ID:</label>
                      <span>{this.state.data.request_id}</span>
                    </div>
                    <div className="form-element">
                      <label>Request Types:</label>
                      <span>
                        {this.state.data.request_type &&
                          this.state.data.request_type.includes("get_info_wf")
                          ? "Info Request"
                          : this.state.data.request_type &&
                            this.state.data.request_type.includes("optout_wf")
                            ? "Opt-Out"
                            : this.state.data.request_type &&
                              this.state.data.request_type.includes(
                                "gpc_opt_out_wf"
                              )
                              ? "GPC Opt-Out"
                              : this.state.data.request_type &&
                                this.state.data.request_type.includes(
                                  "forget_me_wf"
                                )
                                ? "Data Deletion"
                                : this.state.data.request_type &&
                                  this.state.data.request_type.includes(
                                    "close_accnt_wf"
                                  )
                                  ? "Close Account"
                                  : this.state.data.request_type}
                      </span>
                    </div>
                    <div className="form-element">
                      <label>Email:</label>
                      <span>{this.state.data.contact_email}</span>
                    </div>
                    <div className="form-element">
                      <label>Submission Date:</label>
                      <span>{this.state.data.initiated_dttm_cst}</span>
                    </div>
                    {this.state.data.identifier_type === "PHONE_NUMBER" ? (
                      <div className="form-element">
                        <label>Phone Number:</label>
                        <span>{this.state.data.identifier_value.slice(1)}</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {this.state.data.wf_name === "v2_get_info_wf" &&
                    this.state.data.stage === "COMPLETE" ? (
                    <div className="section-col2">
                      <h1>Attachments</h1>
                      <p className="margin-top-1">
                        Please click on the below button to download your
                        personal file.
                      </p>
                      <p className="position-center">
                        <a onClick={this.onDownloadLink}>
                          <button id="Download-btn"> Download </button>
                        </a>
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="display-comments-section">
                  <h1 className="margin-top-1">Request Comments</h1>
                  <div className="reply-button-section">
                    <p className="xss-error">{this.state.xssError}</p>
                    {this.state.showTextEditor ? (
                      <RichTextEditor
                        className="activity-editor"
                        value={this.state.value}
                        onChange={this.onChangeActivityEditor}
                        placeholder="Please enter a message."
                        autoFocus
                      />
                    ) : (
                      ""
                    )}
                    <div className="margin-top-1">
                      {this.state.showTextEditor && this.state.RTELength < 1 ? (
                        <button type="button" id="reply-button" disabled>
                          Reply
                        </button>
                      ) : (
                        <button
                          type="button"
                          id="reply-button"
                          onClick={this.onReplyBtnClick}
                        >
                          Reply
                        </button>
                      )}
                      {this.state.showTextEditor ? (
                        <button
                          type="button"
                          className="btn btn-dark mr-2 margin-left-1"
                          onClick={this.onCancelBtnClick}
                        >
                          {" "}
                          Cancel
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {this.state.commentDetails.length > 0
                    ? this.state.commentDetails.map((data, key) => {
                      return (
                        <div
                          key={key}
                          className="display-comments"
                          style={data.is_inbound === "Y" ? noBg : greyBg}
                        >
                          <span>
                            <i className="fa fa-envelope font-size-18"></i>
                          </span>
                          <span>
                            <span className="font-size-16 text-bold margin-left-1">
                              {data.comment_by}{" "}
                            </span>
                            <span className="position-right">
                              {data.activity_dttm_cst}
                            </span>
                          </span>
                          <div
                            className="display-content"
                            dangerouslySetInnerHTML={{
                              __html: data.activity_content.replace(
                                "#EXTENDED",
                                ""
                              ),
                            }}
                          />
                        </div>
                      );
                    })
                    : ""}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <SpinnerLoad />
        )}
        <Footer />
      </div>
    );
  }
}

export default withToastManager(CustomerPortal);



// WEBPACK FOOTER //
// src/components/CustomerPortal.js